import { cn } from '@/lib/cn';
import faviconMark from '@/assets/brand/favicon.png';

interface TajerGoBrandProps {
    product?: 'Admin' | 'POS' | 'Platform' | 'Marketing OS' | 'Partners';
    tone?: 'light' | 'dark';
    size?: 'sm' | 'md' | 'lg' | 'xl';
    /** Render only the compact favicon "TG" mark (used for collapsed sidebar rail). */
    iconOnly?: boolean;
    className?: string;
}

const sizes = { sm: 'text-xl', md: 'text-2xl', lg: 'text-3xl', xl: 'text-4xl' };

const iconSizes = { sm: 'h-8 w-8', md: 'h-9 w-9', lg: 'h-10 w-10', xl: 'h-12 w-12' };

export function TajerGoBrand({ product, tone = 'light', size = 'md', iconOnly = false, className }: TajerGoBrandProps) {
    // The collapsed rail is 76px wide and the wordmark is not: at size sm it
    // still measures ~90px, so it overflowed the rail. Admin solves this with
    // the square mark, and the two consoles now behave identically.
    if (iconOnly) {
        return (
            <img
                src={faviconMark}
                alt={product ? `TajerGo ${product}` : 'TajerGo'}
                className={cn('rounded-lg object-contain', iconSizes[size], className)}
            />
        );
    }

    return (
        <div className={cn('inline-flex min-w-0 flex-col items-start', className)} aria-label={product ? `TajerGo ${product}` : 'TajerGo'}>
            <span className={cn('whitespace-nowrap font-extrabold tracking-[-0.045em]', sizes[size])} aria-hidden="true">
                <span className={tone === 'dark' ? 'text-white' : 'text-tg-ink'}>Tajer</span><span className="text-tg-orange">Go</span>
            </span>
            {product && <span className={cn('mt-0.5 whitespace-nowrap text-[0.68rem] font-semibold uppercase tracking-[0.18em]', tone === 'dark' ? 'text-white/70' : 'text-tg-muted')}>{product}</span>}
        </div>
    );
}
